window._ = require('lodash');
window.async = require('async');
window.eventBus = require('./core/utils/eventBus');

require('moment/locale/de');
require('moment/locale/ro');
const {regionRelativeUrl} = require("@/core/utils/helpers/regions/regionUrlHelper");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {

    window.Popper = require('popper.js').default;

    // the fancybox package is a jQuery plugin and it binds itself
    // to jQuery global instance.
    // The current webpack configuration provides jQuery instance
    // to a limited scope (module scope).
    // In our situation we want to lazy load Fancybox using $.loadScript
    // from a separate file (not included in the main webpack bundled code)
    // and in order for Fancybox to bind to jQuery
    // we need to expose the instance.
    // -> `global.jQuery` gets converted to `window.jQuery` for web
    $ = window.jQuery = global.jQuery = require('jquery');

    $.getScript({url: regionRelativeUrl('/js/bootstrap.js', true), cache: true}).then(() => {
    });

    window.toastr = require('toastr');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.select2 = require('./scripts/jQuery/select2.min.js');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

/**
 * Debug function to securely view MIX environment variables in production
 * Usage: debugMixValues('your-token-here')
 */
window.debugMixValues = function(token) {
    const secret = process.env.MIX_DEBUG_SECRET;
    if (!secret) {
        return 'Missing token';
    }
    const today = new Date().toISOString().slice(0, 10);
    const validToken = btoa(today + secret);

    if (token === validToken) {
        return {
            MIX_REGION_PATH: process.env.MIX_REGION_PATH,
            MIX_API_URL: process.env.MIX_API_URL,
            MIX_APP_URL: process.env.MIX_APP_URL,
            MIX_MAP_API_KEY: process.env.MIX_MAP_API_KEY,
            MIX_DO_SPACES_PUBLIC_URL: process.env.MIX_DO_SPACES_PUBLIC_URL,
            MIX_IMAGE_PATH: process.env.MIX_IMAGE_PATH,
            MIX_PUSHER_APP_KEY: process.env.MIX_PUSHER_APP_KEY,
            MIX_PUSHER_APP_CLUSTER: process.env.MIX_PUSHER_APP_CLUSTER,
            MIX_CDN2_URL: process.env.MIX_CDN2_URL,
            MIX_CLOUDFARE_SUBDOMAIN: process.env.MIX_CLOUDFARE_SUBDOMAIN,
            MIX_SENTRY_DSN_PUBLIC: process.env.MIX_SENTRY_DSN_PUBLIC,
            MIX_TINYMCE_API_KEY: process.env.MIX_TINYMCE_API_KEY,
            MIX_APP_PHONE_DIAL_CODE: process.env.MIX_APP_PHONE_DIAL_CODE
        };
    }

    return 'Invalid token';
};
